import React from "react";
import PropTypes from 'prop-types';
import { List, Card } from "antd";
// import ActionBtns from "/src/components/ActionBtns/ActionBtns";
const OrgProgrammeListItem = (props) => {
  // console.log("props", props);
  const { item, edited, deleted, actionBtns } = props;
  return (
    <List.Item>
      <Card title={item.key}>
        {actionBtns}
        {item.name} {JSON.stringify(item.settings)}
      </Card>
    </List.Item>
  );
};
OrgProgrammeListItem.defaultProps = {};

OrgProgrammeListItem.propTypes = {};

export default OrgProgrammeListItem;
